import { render, staticRenderFns } from "./team-members.vue?vue&type=template&id=4cba13a6&"
import script from "./team-members.vue?vue&type=script&lang=js&"
export * from "./team-members.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports